<template>
    <div class="wi-access-location-card-root">
        <b-card no-body class="wi-access-location-card">
            <b-row no-gutters>
                <b-col md="3" class="d-flex flex-wrap align-items-center text-center">
                    <img src="../../assets/wifi-icon.svg" alt="Wispot Logo" class="icon" />
                </b-col>
                <b-col md="9">
                    <b-card-body>
                        <b-dropdown variant="none" no-caret class="dropdown drop-icon">
                            <template v-slot:button-content>
                                <font-awesome-icon icon="bars" class="icon" />
                            </template>
                            <b-dropdown-item>
                                <router-link class="drop-link"
                                    :to="{ name: 'sharedProfile', params: { id: accessLocation.cgi_id } }">
                                    <font-awesome-icon icon="user-lock" class="icon" />Informações Compartilhadas
                                </router-link>
                            </b-dropdown-item>
                        </b-dropdown>



                        <p class="title"><strong>{{ accessLocation.name }}</strong></p>
                        <p :title="accessLocation.created_at">{{ created_at }}<font-awesome-icon icon="info-circle"
                                class="icon"
                                title="O tempo informado corresponde ao tempo que a localidade possui seus dados de cadastro." />
                        </p>

                        <b-form-checkbox :value="accessLocation.cgi_id" class="text-right access-location-item-wi" v-model="accessLocationItem"
                            :id="accessLocation.cgi_id" @change="listRevoke(accessLocation)" />

                    </b-card-body>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
<style>
.wi-access-location-card-root {
    display: inline-block;
}

.wi-access-location-card {
    max-width: 300px;
    min-width: 300px;
    margin: 1rem;
}

.wi-access-location-card .card-body {
    padding: 1rem;
}

.wi-access-location-card .card-body p {
    margin: .5rem 0;
}

.wi-access-location-card .card-body p.title {
    margin: .5rem 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 120px;
}

.wi-access-location-card .icon {
    width: 50px;
    ;
    display: inline-block;
    margin: 0 auto;
}

.wi-access-location-card .card-body>.dropdown {
    position: absolute;
    right: 0;
    top: 10px;
    outline: none;
}

.wi-access-location-card .card-body>.dropdown .btn-link {
    color: #ccc;
}

a.drop-link {
    display: block;
    width: 100%;
    padding: 0.25rem 1.5rem;
    clear: both;
    font-weight: 400;
    color: #212529;
    text-align: inherit;
    text-decoration: none;
    white-space: nowrap;
    background-color: transparent;
    border: 0;
}
</style>
<script>
import { mapActions } from 'vuex'

export default {
    data() {
        return {
            accessLocationItem: []
        }
    },
    watch: {
    },
    props: {
        accessLocation: { type: Object, required: true },
    },
    computed: {
        created_at() {
            let created_at = this.$moment(this.accessLocation.created_at, "YYYY-MM-DD HH:mm:ss");
            let diff = this.$moment().diff(created_at);
            return this.$moment.duration(diff).humanize();
        }
    },
    methods: {
        ...mapActions('accessLocations', ['ActionRevoke']),
        listRevoke(object) {
            this.$emit('locationList', object)
        }
    }
}
</script>
